// functions that convert between energy units, e.g. ct/kWh to €/MWh and vice versa

export function ctPerKWhToEuroPerMWh(value: number): number {
  return value * 10;
}

export function euroPerMWhToCtPerKWh(value: number): number {
  return value / 10;
}
